import { useEffect, useState } from "react";

export function useLuxuryCountUp(end, duration = 5500) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let startTime = null;

    const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

    const animate = (time) => {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);
      const eased = easeOutExpo(progress);

      setValue(Math.floor(eased * end));

      if (progress < 1) requestAnimationFrame(animate);
      else setValue(end);
    };

    requestAnimationFrame(animate);
  }, [end, duration]);

  return value;
}
